<span class="col-sm-2">
  <input type="text" 
    class="form-control"     
    placeholder="mm/dd/yyyy" 
    bsDatepicker
    [bsConfig]="bsConfig" 
    placement="top"
    [isDisabled]="isDisabled"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [bsValue]="value"
    [placement]="placement"
    (bsValueChange)="onValueChanged($event)"
    #datePicker="bsDatepicker">
</span>
<i class="fa fa-calendar fa-2x" aria-hidden="true" (click)="datePicker.show()"></i>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/components/ce-date-picker/ce-date-picker.component.html